<style scoped="scoped" lang="scss">
/* .baoyangxianginput {
  width: 30px;
  } */
._form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  color: #606266;
  display: inline-block;
  font-size: inherit;
  // height: 40px;
  line-height: 40px;
  outline: none;
  padding: 0 15px;
  -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
  width: 120px;
}
</style>
<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/custom/jinling/report/production" getKey="rows" :columns="columns" @selectionChange="selectionChange" :isShowChildSelection="false" @finishRemove="setDisabledStatus">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('riqi')">
            <yi_time_input type="datetimerange" :start.sync="yt.conditions.createTimeStart" :end.sync="yt.conditions.createTimeEnd">
            </yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('shengchanrukudanhao')">
            <el-input v-model="yt.conditions.attribute1"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shengchandingdanhao')">
            <el-input v-model="yt.conditions.erpNo"></el-input>
          </el-form-item>
          <el-form-item :label="$t('erpwuliaobianma')">
            <el-input v-model="yt.conditions.erpMaterialCode"></el-input>
          </el-form-item>
          <el-form-item :label="$t('shebeimingcheng')">
            <yi_data_select :multiple="true" :type="'equipment'" :ids.sync="yt.conditions.equipmentIds"> </yi_data_select>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear(
                  {
                    createTimeStart: dayjs()
                      .startOf('month')
                      .valueOf(),
                      createTimeEnd: dayjs()
                      .endOf('month')
                      .valueOf(),
                  },
                  null,
                  afterReq
                )">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button :isAutoExpand="true"></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button v-if="utils.checkPower('report_produce_report_jinling_export')" size="mini" icon="yicon yicon-export" :title="$t('daochu')" :loading="exportLoading" @click="exportExcel"></el-button>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <template #caozuo="scope">
        <div
          @click.stop="
            e => {
              e.stopPropagation();
            }
          "
        >
          <el-row :gutter="10">
            <el-col v-if="scope.row.children || scope.row.parentId == null" :span="0.1">
              <el-button
                type="text"
                v-if="utils.checkPower('web_scheduling_production_plan_dismantlingDoc')"
                @click="
                  yt.showEditDialog('chaidan', scope.row, 'w1', beforeShowSplitDialog);
                  setDefaultValue();
                "
                >{{ $t('chaidan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button v-if="scope.row.schedulingQuantity > 0 || utils.checkPower('web_scheduling_production_plan_start_wo_button')" type="text" @click="yt.showEditDialog('shengchangongdan', scope.row, '80%')">
                {{ $t('shengchangongdan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1" v-if="scope.row.children || scope.row.parentId == null">
              <el-button v-if="scope.row.status == 1 || utils.checkPower('web_scheduling_production_plan_dismantlingDoc')" type="text" @click="yt.showEditDialog('bianji', scope.row, 'w2', beforeEdit)">{{ $t('bianji') }} </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button type="text" v-if="scope.row.type == 1" @click="yt.showEditDialog('hedanjilu', scope.row, '900px')">
                {{ $t('hedanjilu') }}
              </el-button>
            </el-col>
            <el-col v-if="scope.row.children || scope.row.parentId == null" :span="0.1">
              <el-button :loading="yt.editObj.loading" v-if="scope.row.schedulingQuantity == 0 || utils.checkPower('web_scheduling_production_plan_delete')" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/aps/plan/delete')">{{ $t('shanchu') }} </el-button>
              <el-button v-if="scope.row.schedulingQuantity == 0 && scope.row.parentId == null && utils.checkPower('web_aps_order_management_production_plan_addChildrenPlan')" type="text" @click="yt.showEditDialog('zengjiafudan', scope.row, '1400px', beforeShowEditDialog)">
                {{ $t('zengjiafudan') }}
              </el-button>
            </el-col>
            <el-col :span="0.1">
              <el-button :loading="store.state.global_loading" v-if="utils.checkPower('web_aps_order_management_production_plan_unbind') && scope.row.schedulingQuantity == 0 && scope.row.parentId != null" type="text" @click="unbind(scope.row)">{{ $t('jiechubangding') }} </el-button>
            </el-col>
          </el-row>
        </div>
      </template>
    </yi_curd_table>
  </div>
</template>
<script type="text/javascript">
// import combine from '@@/pages/web/scheduling/production_plan/combine'
import importExcel from '@@/pages/web/scheduling/production_plan/import_excel';
import work_order from '@@/pages/web/scheduling/production_plan/work_order/list';
import existing_plans from '@@/pages/web/scheduling/production_plan/existing_plans';
import { i } from 'mathjs';
// import combination_record from '@@/pages/web/scheduling/production_plan/combination_record'

export default {
  name: 'web_customize_jinling_report_produce_report_list',
  components: {
    importExcel,
    // combine,
    work_order,
    existing_plans
    // combination_record
  },
  data() {
    return {
      exportLoading: false,
      errorPlans: [],
      isShowErrorPlansDialog: false,
      selectIds: [],
      childrenParentId: null,
      combinationData: {},
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      apiParams: {},
      schedulLoading: false,
      startTime: 0,
      EndTime: 0,
      allIds: [],
      checkDisabled: true,
      schedulingQuantityDisabled: true,
      mouldStatus: '',
      objectList: '',
      schedulingList: '',
      parentIds: '',
      scheduling: '',
      cavity: '',
      cycle: '',
      showTitle: false,
      showTitle1: false,
      disabled1: true,
      show: false,
      list: [],
      isShowAdaptEqSelect: true,
      // orderBy: {
      //   orderBy: 'createTime desc'
      // },
      columns: [{
          label: 'riqi',
          prop: 'createTime',
          type: 'time',
          width: 180
        },
        {
          label: 'shebeimingcheng',
          prop: 'equipmentName',
          sort: 'string',
          width: 130
        },
        {
          label: 'shengchanrukudanhao',
          prop: 'attribute1',
          sort: 'string',
          width: 130
        },
        {
          label: 'shengchandingdanhao',
          prop: 'erpNo',
          sort: 'string',
          width: 130
        },
        {
          label: 'mujubianma',
          prop: 'mouldCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinbianhao',
          prop: 'materialCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'erpwuliaobianma',
          prop: 'erpMaterialCode',
          sort: 'string',
          width: 130
        },
        {
          label: 'chanpinmingcheng',
          prop: 'materialName',
          sort: 'string',
          width: 130
        },
        {
          label: 'guigexinghao',
          prop: 'spec',
          sort: 'string',
          width: 130
        },
        {
          label: 'biaozhunzhouqi(miao)',
          prop: 'standardCycle',
          sort: 'string',
          width: 130
        },
        {
          label: 'muxueshu',
          prop: 'cavity',
          sort: 'string',
          width: 130
        },
        {
          label: 'shijizhouqi(miao)',
          prop: 'cycle',
          sort: 'string',
          width: 130
        },
        {
          label: 'caozuoren',
          prop: 'attribute2',
          sort: 'string',
          width: 130
        },
        {
          label: 'wangongshuliang',
          prop: 'goodQuantity',
          sort: 'number',
          width: 130
        },
        {
          label: 'banci',
          prop: 'shiftName',
          sort: 'string',
          width: 130
        }
      ],

      ids: '',
      arrList: []
    };
  },
  computed: {
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        orderBy: 'createTime desc'
      }
      this.yt.conditions.createTimeStart = this.dayjs()
        .startOf("month")
        .valueOf();
      this.yt.conditions.createTimeEnd = this.dayjs()
        .endOf("month")
        .valueOf();
      this.yt.get(1);
    }, 300);
  },
  watch: {
  },
  methods: {
    // 导出Excel
    exportExcel() {
      this.exportLoading = true;
      let params = this.yt.conditions;
      return this.http
        .get('/web/report/export/data_handle_stategy_report_produce_jinling_export?orderBy=createTime desc', {
          params
        })
        .then(res => {
          this.$message.success(this.$t(res.msg))
          this.exportLoading = false;
          this.utils.event_hub.$emit('SHOW_HEADER_EXPORT_DIALOG');
        })
        .catch(error => {
          this.exportLoading = false;
          this.$message.error(this.$t(error));
        });
    },
    
  }
};
</script>
